/**
 * @fileoverview DELETE handler for the "/apps/business/accounts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessAccountsCacheKeys } from "./constants";
import type { DeleteAppsBusinessAccountsProps, AppsBusinessAccountsResult } from "./types";

export const deleteAppsBusinessAccounts = reactQueryMutationAdapter(
  appsBusinessAccountsCacheKeys,
  (props: DeleteAppsBusinessAccountsProps): Promise<AppsBusinessAccountsResult> => {
    return fetch("/apps/business/accounts", "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
